export const NodeType = {
  text: 'text',
  node: 'node'
};
